module.exports = __webpack_public_path__ + "media/images/users/user-8-b89db3fe112719fb1e054692a21b073b.jpg";